var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('m-mail-auth'),_vm._v(" "),_c('div',{staticClass:"m-btns"},[_c('div',{staticClass:"m-btn -st",on:{"click":function($event){return _vm.onClose()}}},[_c('span',{staticClass:"en"},[_vm._v("OK")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }